import { useCallback } from 'react';
import useMountedState from './use-mounted-state';
export default (function () {
  var isMounted = useMountedState();
  return useCallback(function (promise) {
    return new Promise(function (resolve, reject) {
      promise.then(function (result) {
        if (isMounted()) {
          resolve(result);
        }
      }).catch(function (error) {
        if (isMounted()) {
          reject(error);
        }
      });
    });
  }, [isMounted]);
});